import React from 'react';
import { FormModal, FormField } from '../../../components/ui/Modal';
import { useAddSupplierModal } from './AddSupplierModal.hooks';

interface AddSupplierModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: {
    nombre: string;
    contacto: string;
    telefono: string;
    email: string;
    descripcion: string;
  }) => Promise<void>;
}

const AddSupplierModal: React.FC<AddSupplierModalProps> = ({ isOpen, onClose, onSave }) => {
  const { formData, loading, error, handleFormChange, handleSave, handleClose } =
    useAddSupplierModal();

  const fields: FormField[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      placeholder: 'Ej. Villa Imperial',
      required: true,
    },
    {
      name: 'telefono',
      label: 'Teléfono',
      type: 'tel',
      placeholder: 'Ej. 71234567',
    },
    {
      name: 'email',
      label: 'Correo',
      type: 'email',
      placeholder: 'Ej. contacto@proveedor.com',
    },
    {
      name: 'contacto',
      label: 'Persona de contacto',
      type: 'text',
      placeholder: 'Ej. Juan Pérez',
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      placeholder: 'Notas adicionales sobre el proveedor...',
      rows: 4,
    },
  ];

  const handleSaveClick = async () => {
    await handleSave(onSave);
  };

  // Convert formData to Record<string, string> for FormModal
  const formDataRecord: Record<string, string> = {
    nombre: formData.nombre || '',
    contacto: formData.contacto || '',
    telefono: formData.telefono || '',
    email: formData.email || '',
    descripcion: formData.descripcion || '',
  };

  return (
    <FormModal
      open={isOpen}
      onClose={() => handleClose(onClose)}
      title="Agregar Proveedor"
      fields={fields}
      formData={formDataRecord}
      onFieldChange={handleFormChange}
      onSave={handleSaveClick}
      loading={loading}
      error={error}
      saveButtonText="Guardar"
      cancelButtonText="Cancelar"
      maxWidth="sm"
      variant="simple"
    />
  );
};

export default AddSupplierModal;
